import React from 'react'
import { ArrowRight } from 'lucide-react'

const MOCK = [
  { id: 1, title: 'Halong Bay vs Lan Ha Bay: Which Should You Choose?', date: 'Mar 2025', link: '#' },
  { id: 2, title: 'Best Time to Cruise Halong Bay', date: 'Feb 2025', link: '#' },
  { id: 3, title: 'Kayaking Through Luon Cave', date: 'Jan 2025', link: '#' },
  { id: 4, title: 'The Seafood of Halong Bay', date: 'Dec 2024', link: '#' },
  { id: 5, title: 'Packing for a Halong Cruise', date: 'Nov 2024', link: '#' },
]

export default function RelatedPosts({ posts, category }) {
  const list = posts?.length
    ? [...posts].sort((a, b) => new Date(b.dateRaw ?? b.date) - new Date(a.dateRaw ?? a.date)).slice(0, 8)
    : MOCK
  if (!list.length) return null

  return (
    <section className="sp-related">
      <div className="sp-related__header">
        <span className="sp-related__label">
          {category ? `More in ${category}` : 'Continue Reading'}
        </span>
        <div className="sp-related__rule" />
      </div>

      <ul className="sp-related__list">
        {list.map(post => (
          <li key={post.id} className="sp-related__item">
            <div className="sp-related__body">
              {post.date && <span className="sp-related__date">{post.date}</span>}
              <a href={post.link} className="sp-related__title">{post.title}</a>
            </div>
            <a href={post.link} className="sp-related__arrow" aria-label="Read">
              <ArrowRight size={14} strokeWidth={1.5} />
            </a>
          </li>
        ))}
      </ul>
    </section>
  )
}
